import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { HexColorPicker } from 'react-colorful';

const ColorPickerGrid = ({ open, onClose, selectedColor, onColorSelect }) => {
  const [tempColor, setTempColor] = useState(selectedColor);

  // Reset the temporary color when the dialog is opened
  useEffect(() => {
    if (open) {
      setTempColor(selectedColor);
    }
  }, [open, selectedColor]);

  const handleSelect = () => {
    onColorSelect(tempColor);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Select a Color</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle2" gutterBottom>
          Choose a color using the wheel:
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <HexColorPicker color={tempColor} onChange={setTempColor} />
        </Box>
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="body1">
            {tempColor.toUpperCase()}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSelect} variant="contained">
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPickerGrid;
